'use client';

import { colors } from '@/lib/brand';

// Component to visually validate brand navy is applied to headers/footers
export function BrandValidation() {
  if (process.env.NODE_ENV !== 'development') return null;

  return (
    <div className="fixed bottom-4 right-4 z-[9999] bg-white border border-gray-300 rounded-lg p-3 shadow-lg text-xs">
      <div className="font-semibold mb-2">Brand Validation</div>
      <div className="space-y-1">
        <div className="flex items-center space-x-2">
          <div 
            className="w-4 h-4 border border-gray-300" 
            style={{ backgroundColor: colors.headerFooterBg }}
          ></div>
          <span>Header/Footer: {colors.headerFooterBg}</span>
        </div>
        <div className="flex items-center space-x-2">
          <div 
            className="w-4 h-4 border border-gray-300" 
            style={{ backgroundColor: colors.textOnDark }}
          ></div>
          <span>Text on Dark: {colors.textOnDark}</span>
        </div>
        <div className="text-green-600 text-xs">✓ Navy rule enforced</div>
      </div>
    </div>
  );
}